var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountSettings = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 2.5c-1.652 0-3 1.348-3 3s1.348 3 3 3 3-1.348 3-3-1.348-3-3-3Zm0 6A5.012 5.012 0 0 0 3.025 13c-.028.275.199.5.475.5.276 0 .497-.225.53-.499A3.992 3.992 0 0 1 8 9.5a3.992 3.992 0 0 1 3.97 3.501c.033.274.254.499.53.499s.503-.225.475-.5A5.012 5.012 0 0 0 8 8.5Zm0-5c1.11 0 2 .89 2 2 0 1.11-.89 2-2 2-1.11 0-2-.89-2-2 0-1.11.89-2 2-2Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountSettings);
export default ForwardRef;